export default "__VITE_PUBLIC_ASSET__7bb6e607__"